import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

import { EMPLOYEE_BONUS_LIST } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
// Reducer
import { setEmployeeBonusQueries } from 'src/reducers/employees/employeeBonus';
// Utils
import { formatDate } from 'src/utils/Date';
import { ErrorsSection } from 'src/components';
// Form
import EmployeeBonusDownloadCsvForm from './components/EmployeeBonusDownloadCsvForm';
import DownloadColumnDetail from './components/DownloadColumnDetail';

import styles from './DownloadCsvPage.scss';

class ConnectedDownloadCsv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: null
    };
    this.updateState = this.updateState.bind(this);
  }

  updateState(state) {
    this.setState(state);
  }

  render() {
    const { clientBonus } = this.props;

    return (
      <div>
        <div className="l-wrap-xs l-contents-wrap">
          <BreadCrumb>
            <BreadCrumb.Item label={i18next.t('features.EmployeeBonus.DownloadCsvPage.bonus_list')} path={EMPLOYEE_BONUS_LIST} />
            <BreadCrumb.Item label={i18next.t('features.EmployeeBonus.DownloadCsvPage.update_provision_and_deduction_items')} />
          </BreadCrumb>
        </div>
        <div className="l-title-wrap">
          <h1 className="m-title-main">{i18next.t('features.EmployeeBonus.DownloadCsvPage.update_provision_and_deduction_items')}</h1>
        </div>
        <div className="l-wrap-xs">
          <ErrorsSection errors={this.state.errors} />
          <p>
            {i18next.t('features.EmployeeBonus.DownloadCsvPage.The_following_months_bonus_provision_and_deduction_items_can_be_updated_in_a_batch_using_CSV_file')}<br />{i18next.t('features.EmployeeBonus.DownloadCsvPage.useful_for_managing_provision_items_that_change_every_month')}
          </p>
          <ul className="u-mt10">
            <li>
              ※ {i18next.t('features.EmployeeBonus.DownloadCsvPage.values_in_employee_master_data_cannot_be_changed')}<a
                href="https://dev-donuts-payroll-xxx.de/employees/update_batch_csv"
                className="u-txt-link"
              >
                {i18next.t('features.Dashbord.components.Setup.here')}
              </a>
            </li>
          </ul>
          <div className={styles.target}>
            {i18next.t('features.EmployeeBonus.DownloadCsvPage.bonus_name')}: {clientBonus.name}
            {(clientBonus.applyForTimeFrom || clientBonus.applyForTimeTo) && (
              <div className={styles.period}>
                <span>
                  {i18next.t('features.EmployeeBonus.DownloadCsvPage.subjected_period')}: {formatDate(clientBonus.applyForTimeFrom)} ~ {formatDate(clientBonus.applyForTimeTo)}
                </span>
              </div>
            )}
          </div>
        </div>
        <EmployeeBonusDownloadCsvForm updateState={this.updateState} />
        <div className={styles.detail}>
          <DownloadColumnDetail />
        </div>
      </div>
    );
  }
}


const DownloadCsvPage = ({ dispatch, values }) => {
  const clientBonus = values.clientBonus;
  dispatch(setEmployeeBonusQueries(values.queries));
  return (
    <ConnectedDownloadCsv clientBonus={clientBonus} />
  );
};
export default withTranslation('translation')(connect()(DownloadCsvPage));
